/* import __COLOCATED_TEMPLATE__ from './signal-inputs.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import Consts from '../../utils/constants';
import PrettyNum from '../../utils/pretty-num-wrapper';

export default class SignalInputs extends Component {
    tagName = '';

    @service('data') model;
    @service intl;
    @service urlData;
    @service selectionData;
    @service driverSupplyService;
    @service driverService;
    @service componentManager;
    @service errorHandling;
    @service hashDataService;
    @service hashService;
    @service sigmaDeltaData;

    multiplexedBodyArgs = {};

    panelHeadingBodyArgs = {};
    qaAttrValue = `${Consts.QA_ATTR_PREFIX}_input_bx`;

    init() {
        super.init();

        this.multiplexedBodyArgs = {
            analogDemystifyingDataArticleLink: this.intl.t('urls.articles.demystifyingData'),
            analogFrontEndDesignArticleLink: this.intl.t('urls.articles.frontEndDesign'),
        };

        this.set('componentManager.signalInputs', this);
    }

    @action openCardTooltip() {
        if (this.openHelp) {
            this.openHelp(`info_modal.input_signal_input.title`, `info_modal.input_signal_input.body`, {
                ...this.panelHeadingBodyArgs,
            });
        }
    }

    @action onSelectedSourceTypeChange() {
        this.driverService.setTopologyStatus();
        this.driverService.defaultRf();
        this.driverService.resetGain();
        this.driverService.resetRf();
        this.driverService.defaultCf();
        this.driverService.resetCf();

        this.driverSupplyService.calculateVSupply();

        this.hashDataService.setUrlParameter('model.rf');
        this.hashDataService.setUrlParameter('model.gain');
        this.hashDataService.setUrlParameter('model.vSupplyPos');
        this.hashDataService.setUrlParameter('model.vSupplyNeg');

        this.hashDataService.setUrlParameterWithSelectedId('topology');
        this.hashDataService.setUrlParameterWithSelectedId('sourceType');

        if (this.updateAppData) this.updateAppData();
    }

    @action onFrequencyChange() {
        this.hashDataService.setUrlParameter('model.frequency');

        if (this.updateAppData) this.updateAppData();
    }

    @action onVcmChange() {
        this.driverSupplyService.calculateVSupply();

        this.hashDataService.setUrlParameter('model.vcm', this.model.isVcmFixed);
        this.hashDataService.setUrlParameter('model.vSupplyPos');
        this.hashDataService.setUrlParameter('model.vSupplyNeg');

        if (this.updateAppData) this.updateAppData();
    }

    @action onMultiplexedChange() {
        // Not sure why this needs to be done or if it will need to be done when we convert to <> syntax
        this.set('model.multiplexed', !this.model.multiplexed);

        this.hashDataService.setUrlParameter('model.multiplexed');

        if (this.updateAppData) this.updateAppData();
    }

    @computed('selectionData.selectedAdc.type') get inputTypeDisabled() {
        return this.selectionData.selectedAdc.type === Consts.ADC_TYPE.SE;
    }

    @computed('model.{vout,gain}', 'selectionData.{selectedDriver.type,selectedSourceType.id}') get vinDisplay() {
        let vout = this.model.vout,
            gain = this.model.gain,
            driverType = this.selectionData.selectedDriver.type,
            sourceType = this.selectionData.selectedSourceType.id,
            vin;

        vin = vout / gain;

        if (driverType === Consts.DRIVER_TYPE.DIFF_AMP && sourceType === Consts.SOURCE_TYPE.SE) {
            vin = vin * 2;
        }

        return PrettyNum.eng4(vin);
    }

    /**
     * Can only be used in initialLoadWithHash
     */
    canCalculateProperty(propertyName) {
        let hashValues = this.hashService.parsedLocationHash;
        return !(hashValues[propertyName] && Number(hashValues[propertyName]) !== 0);
    }

    initialLoadWithHash() {
        // Make sure the url data is set
        this.hashDataService.setUrlParameter('model.vcm', this.model.isVcmFixed);
        this.hashDataService.setUrlParameter('model.frequency');
        this.hashDataService.setUrlParameter('model.multiplexed');
        this.hashDataService.setUrlParameterWithSelectedId('sourceType');
    }

    initialLoadWithoutHash() {
        // Make sure the url data is set
        this.hashDataService.setUrlParameter('model.vcm', this.model.isVcmFixed);
        this.hashDataService.setUrlParameter('model.frequency');
        this.hashDataService.setUrlParameter('model.multiplexed');
        this.hashDataService.setUrlParameterWithSelectedId('sourceType');
    }
}
